export class NetworkError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "NetworkError";
        Object.setPrototypeOf(this, new.target.prototype);
    }
}